// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"566":"242121dc","708":"a9c3a1a9","956":"9cbcc5f6"}[chunkId] + ".chunk.js";
};